// extracted by mini-css-extract-plugin
export default {"manage":"_manageaccount_manage__jMQpQ","manage__button":"_manageaccount_manage__button__FbJ5a"};